"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatedRegistry = void 0;
exports.generatedRegistry = {
    "nav": {
        "label": "Navigasyon",
        "group": "common",
        "fields": {
            "home": {
                "type": "text",
                "label": "Home"
            },
            "corporate": {
                "type": "text",
                "label": "Corporate"
            },
            "about": {
                "type": "text",
                "label": "About"
            },
            "brands": {
                "type": "text",
                "label": "Brands"
            },
            "blog": {
                "type": "text",
                "label": "Blog"
            },
            "contact": {
                "type": "text",
                "label": "Contact"
            },
            "contactBtn": {
                "type": "text",
                "label": "Contact Btn"
            },
            "b2bBtn": {
                "type": "text",
                "label": "B2b Btn"
            },
            "history": {
                "type": "text",
                "label": "History"
            },
            "values": {
                "type": "text",
                "label": "Values"
            },
            "socialResponsibility": {
                "type": "text",
                "label": "Social Responsibility"
            },
            "infoSociety": {
                "type": "text",
                "label": "Info Society"
            },
            "hr": {
                "type": "text",
                "label": "Hr"
            },
            "hrPolicy": {
                "type": "text",
                "label": "Hr Policy"
            },
            "career": {
                "type": "text",
                "label": "Career"
            },
            "qualityPolicy": {
                "type": "text",
                "label": "Quality Policy"
            },
            "itTech": {
                "type": "text",
                "label": "It Tech"
            },
            "otvtTech": {
                "type": "text",
                "label": "Otvt Tech"
            },
            "cctvTech": {
                "type": "text",
                "label": "Cctv Tech"
            }
        }
    },
    "layout": {
        "label": "Logo & Marka",
        "group": "common",
        "fields": {
            "logo": {
                "type": "text",
                "label": "Logo"
            },
            "favicon": {
                "type": "text",
                "label": "Favicon"
            }
        }
    },
    "hero": {
        "label": "Ana Hero",
        "group": "common",
        "fields": {
            "badge": {
                "type": "text",
                "label": "Badge"
            },
            "title1": {
                "type": "text",
                "label": "Title1"
            },
            "title2": {
                "type": "text",
                "label": "Title2"
            },
            "title3": {
                "type": "text",
                "label": "Title3"
            },
            "subtitle": {
                "type": "text",
                "label": "Subtitle"
            },
            "companyName": {
                "type": "text",
                "label": "Company Name"
            },
            "since": {
                "type": "text",
                "label": "Since"
            },
            "cta1": {
                "type": "text",
                "label": "Cta1"
            },
            "cta2": {
                "type": "text",
                "label": "Cta2"
            },
            "stat1": {
                "type": "text",
                "label": "Stat1"
            },
            "stat2": {
                "type": "text",
                "label": "Stat2"
            },
            "stat3": {
                "type": "text",
                "label": "Stat3"
            },
            "stat4": {
                "type": "text",
                "label": "Stat4"
            }
        }
    },
    "customer": {
        "label": "Müşteri Bloğu",
        "group": "common",
        "fields": {
            "label": {
                "type": "text",
                "label": "Label"
            },
            "title": {
                "type": "text",
                "label": "Title"
            },
            "subtitle": {
                "type": "textarea",
                "label": "Subtitle"
            },
            "cta": {
                "type": "text",
                "label": "Cta"
            },
            "ctaTitle": {
                "type": "text",
                "label": "Cta Title"
            },
            "feature1": {
                "type": "text",
                "label": "Feature1"
            },
            "feature1d": {
                "type": "text",
                "label": "Feature1d"
            },
            "feature2": {
                "type": "text",
                "label": "Feature2"
            },
            "feature2d": {
                "type": "textarea",
                "label": "Feature2d"
            },
            "feature3": {
                "type": "text",
                "label": "Feature3"
            },
            "feature3d": {
                "type": "text",
                "label": "Feature3d"
            },
            "feature4": {
                "type": "text",
                "label": "Feature4"
            },
            "feature4d": {
                "type": "text",
                "label": "Feature4d"
            }
        }
    },
    "brands": {
        "label": "Markalar (Ortak)",
        "group": "common",
        "fields": {
            "label": {
                "type": "text",
                "label": "Label"
            },
            "title": {
                "type": "text",
                "label": "Title"
            },
            "subtitle": {
                "type": "text",
                "label": "Subtitle"
            },
            "viewAll": {
                "type": "text",
                "label": "View All"
            }
        }
    },
    "blog": {
        "label": "Blog (Ortak)",
        "group": "common",
        "fields": {
            "label": {
                "type": "text",
                "label": "Label"
            },
            "title": {
                "type": "text",
                "label": "Title"
            },
            "subtitle": {
                "type": "text",
                "label": "Subtitle"
            },
            "viewAll": {
                "type": "text",
                "label": "View All"
            },
            "readMore": {
                "type": "text",
                "label": "Read More"
            }
        }
    },
    "newsletter": {
        "label": "Bülten",
        "group": "common",
        "fields": {
            "title": {
                "type": "text",
                "label": "Title"
            },
            "subtitle": {
                "type": "textarea",
                "label": "Subtitle"
            },
            "placeholder": {
                "type": "text",
                "label": "Placeholder"
            },
            "btn": {
                "type": "text",
                "label": "Btn"
            },
            "success": {
                "type": "text",
                "label": "Success"
            },
            "error": {
                "type": "text",
                "label": "Error"
            },
            "connectionError": {
                "type": "text",
                "label": "Connection Error"
            }
        }
    },
    "contact": {
        "label": "İletişim (Ortak)",
        "group": "common",
        "fields": {
            "label": {
                "type": "text",
                "label": "Label"
            },
            "title": {
                "type": "text",
                "label": "Title"
            },
            "subtitle": {
                "type": "textarea",
                "label": "Subtitle"
            },
            "address": {
                "type": "text",
                "label": "Address"
            },
            "phone": {
                "type": "text",
                "label": "Phone"
            },
            "email": {
                "type": "text",
                "label": "Email"
            },
            "hours": {
                "type": "text",
                "label": "Hours"
            },
            "name": {
                "type": "text",
                "label": "Name"
            },
            "subject": {
                "type": "text",
                "label": "Subject"
            },
            "message": {
                "type": "text",
                "label": "Message"
            },
            "send": {
                "type": "text",
                "label": "Send"
            },
            "sending": {
                "type": "text",
                "label": "Sending"
            },
            "success": {
                "type": "text",
                "label": "Success"
            },
            "successNote": {
                "type": "text",
                "label": "Success Note"
            },
            "newMsg": {
                "type": "text",
                "label": "New Msg"
            }
        }
    },
    "footer": {
        "label": "Footer",
        "group": "common",
        "fields": {
            "slogan": {
                "type": "text",
                "label": "Slogan"
            },
            "desc": {
                "type": "textarea",
                "label": "Desc"
            },
            "quickMenu": {
                "type": "text",
                "label": "Quick Menu"
            },
            "corporate": {
                "type": "text",
                "label": "Corporate"
            },
            "workingHours": {
                "type": "text",
                "label": "Working Hours"
            },
            "workingHoursText": {
                "type": "text",
                "label": "Working Hours Text"
            },
            "copyright": {
                "type": "textarea",
                "label": "Copyright"
            },
            "kvkk": {
                "type": "text",
                "label": "Kvkk"
            },
            "cookiePolicy": {
                "type": "text",
                "label": "Cookie Policy"
            },
            "privacy": {
                "type": "text",
                "label": "Privacy"
            },
            "scrollToTop": {
                "type": "text",
                "label": "Scroll To Top"
            },
            "itTech": {
                "type": "text",
                "label": "It Tech"
            },
            "cctvTech": {
                "type": "text",
                "label": "Cctv Tech"
            },
            "otvtTech": {
                "type": "text",
                "label": "Otvt Tech"
            }
        }
    },
    "hizmetler": {
        "label": "Hizmetler Menüsü",
        "group": "pages",
        "fields": {
            "heroTitle1": {
                "type": "text",
                "label": "Hero Title1"
            },
            "heroTitle2": {
                "type": "text",
                "label": "Hero Title2"
            },
            "heroTitle3": {
                "type": "text",
                "label": "Hero Title3"
            },
            "heroTitle4": {
                "type": "text",
                "label": "Hero Title4"
            },
            "heroTitle5": {
                "type": "text",
                "label": "Hero Title5"
            },
            "heroTitle6": {
                "type": "text",
                "label": "Hero Title6"
            },
            "heroTitle7": {
                "type": "text",
                "label": "Hero Title7"
            },
            "strongTitle": {
                "type": "text",
                "label": "Strong Title"
            },
            "fastTitle": {
                "type": "text",
                "label": "Fast Title"
            },
            "sustainableTitle": {
                "type": "text",
                "label": "Sustainable Title"
            },
            "whatWeOffer": {
                "type": "text",
                "label": "What We Offer"
            },
            "strongPartners": {
                "type": "text",
                "label": "Strong Partners"
            },
            "strongPartnersDesc": {
                "type": "textarea",
                "label": "Strong Partners Desc"
            },
            "wideProducts": {
                "type": "text",
                "label": "Wide Products"
            },
            "wideProductsDesc": {
                "type": "textarea",
                "label": "Wide Products Desc"
            },
            "qualityAssurance": {
                "type": "text",
                "label": "Quality Assurance"
            },
            "qualityAssuranceDesc": {
                "type": "textarea",
                "label": "Quality Assurance Desc"
            },
            "differentTitle": {
                "type": "text",
                "label": "Different Title"
            },
            "differentDesc": {
                "type": "textarea",
                "label": "Different Desc"
            },
            "websiteTitle": {
                "type": "text",
                "label": "Website Title"
            },
            "websiteDesc": {
                "type": "textarea",
                "label": "Website Desc"
            },
            "logisticsTitle": {
                "type": "text",
                "label": "Logistics Title"
            },
            "logisticsDesc": {
                "type": "textarea",
                "label": "Logistics Desc"
            },
            "depomTitle": {
                "type": "text",
                "label": "Depom Title"
            },
            "depomDesc": {
                "type": "textarea",
                "label": "Depom Desc"
            },
            "depomAdvantages": {
                "type": "textarea",
                "label": "Depom Advantages"
            },
            "entegrasyonTitle": {
                "type": "text",
                "label": "Entegrasyon Title"
            },
            "entegrasyonDesc": {
                "type": "textarea",
                "label": "Entegrasyon Desc"
            },
            "techServiceTitle": {
                "type": "text",
                "label": "Tech Service Title"
            },
            "techServiceDesc": {
                "type": "text",
                "label": "Tech Service Desc"
            },
            "cctvTitle": {
                "type": "text",
                "label": "Cctv Title"
            },
            "cctvDesc": {
                "type": "textarea",
                "label": "Cctv Desc"
            },
            "otvtTitle": {
                "type": "text",
                "label": "Otvt Title"
            },
            "otvtDesc": {
                "type": "textarea",
                "label": "Otvt Desc"
            },
            "techCenterTitle": {
                "type": "text",
                "label": "Tech Center Title"
            },
            "techCenterDesc": {
                "type": "textarea",
                "label": "Tech Center Desc"
            }
        }
    },
    "homePage": {
        "label": "Anasayfa",
        "group": "pages",
        "fields": {
            "heroBadge": {
                "type": "text",
                "label": "Hero Badge"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroSubtitle": {
                "type": "textarea",
                "label": "Hero Subtitle"
            },
            "ctaServices": {
                "type": "text",
                "label": "Cta Services"
            },
            "ctaPartner": {
                "type": "text",
                "label": "Cta Partner"
            },
            "statExp": {
                "type": "text",
                "label": "Stat Exp"
            },
            "statPartners": {
                "type": "text",
                "label": "Stat Partners"
            },
            "statBrands": {
                "type": "text",
                "label": "Stat Brands"
            },
            "statCoverage": {
                "type": "text",
                "label": "Stat Coverage"
            },
            "aboutTitle": {
                "type": "text",
                "label": "About Title"
            },
            "aboutDesc": {
                "type": "textarea",
                "label": "About Desc"
            },
            "valuesTitle": {
                "type": "text",
                "label": "Values Title"
            },
            "valuesDesc": {
                "type": "textarea",
                "label": "Values Desc"
            },
            "brandsTitle": {
                "type": "text",
                "label": "Brands Title"
            },
            "brandsDesc": {
                "type": "textarea",
                "label": "Brands Desc"
            },
            "itBrands": {
                "type": "text",
                "label": "It Brands"
            },
            "otvtBrands": {
                "type": "text",
                "label": "Otvt Brands"
            },
            "cctvBrands": {
                "type": "text",
                "label": "Cctv Brands"
            },
            "whyTitle": {
                "type": "text",
                "label": "Why Title"
            },
            "whyDesc": {
                "type": "text",
                "label": "Why Desc"
            },
            "moreInfo": {
                "type": "text",
                "label": "More Info"
            },
            "blogBadge": {
                "type": "text",
                "label": "Blog Badge"
            },
            "blogTitle": {
                "type": "text",
                "label": "Blog Title"
            },
            "blogDesc": {
                "type": "text",
                "label": "Blog Desc"
            },
            "blogViewAll": {
                "type": "text",
                "label": "Blog View All"
            },
            "blogEmpty": {
                "type": "text",
                "label": "Blog Empty"
            },
            "brandsViewAll": {
                "type": "text",
                "label": "Brands View All"
            }
        }
    },
    "hakkimizda": {
        "label": "Hakkımızda Menüsü",
        "group": "pages",
        "fields": {
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDesc": {
                "type": "textarea",
                "label": "Hero Desc"
            },
            "whoWeAre": {
                "type": "text",
                "label": "Who We Are"
            },
            "whoWeAreDesc": {
                "type": "textarea",
                "label": "Who We Are Desc"
            },
            "whoWeAreDesc2": {
                "type": "textarea",
                "label": "Who We Are Desc2"
            },
            "check1": {
                "type": "text",
                "label": "Check1"
            },
            "check2": {
                "type": "text",
                "label": "Check2"
            },
            "check3": {
                "type": "text",
                "label": "Check3"
            },
            "moreInfo": {
                "type": "text",
                "label": "More Info"
            },
            "valuesLabel": {
                "type": "text",
                "label": "Values Label"
            },
            "valuesTitle": {
                "type": "text",
                "label": "Values Title"
            },
            "timelineLabel": {
                "type": "text",
                "label": "Timeline Label"
            },
            "timelineTitle": {
                "type": "text",
                "label": "Timeline Title"
            },
            "missionTitle": {
                "type": "text",
                "label": "Mission Title"
            },
            "missionDesc": {
                "type": "textarea",
                "label": "Mission Desc"
            },
            "visionTitle": {
                "type": "text",
                "label": "Vision Title"
            },
            "visionDesc": {
                "type": "textarea",
                "label": "Vision Desc"
            },
            "ctaTitle": {
                "type": "text",
                "label": "Cta Title"
            },
            "ctaDesc": {
                "type": "text",
                "label": "Cta Desc"
            },
            "ctaBtn": {
                "type": "text",
                "label": "Cta Btn"
            },
            "yearsExperience": {
                "type": "text",
                "label": "Years Experience"
            }
        }
    },
    "aboutPage": {
        "label": "Hakkımızda Sayfası",
        "group": "pages",
        "fields": {
            "heroImage": {
                "type": "text",
                "label": "Hero Image"
            },
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDescription": {
                "type": "textarea",
                "label": "Hero Description"
            },
            "sectionLabel": {
                "type": "text",
                "label": "Section Label"
            },
            "sectionTitle": {
                "type": "text",
                "label": "Section Title"
            },
            "years": {
                "type": "text",
                "label": "Years"
            },
            "yearsLabel": {
                "type": "text",
                "label": "Years Label"
            },
            "description1": {
                "type": "textarea",
                "label": "Description1"
            },
            "description2": {
                "type": "textarea",
                "label": "Description2"
            },
            "check1": {
                "type": "text",
                "label": "Check1"
            },
            "check2": {
                "type": "text",
                "label": "Check2"
            },
            "check3": {
                "type": "text",
                "label": "Check3"
            },
            "valuesLabel": {
                "type": "text",
                "label": "Values Label"
            },
            "valuesTitle": {
                "type": "text",
                "label": "Values Title"
            },
            "value1Title": {
                "type": "text",
                "label": "Value1 Title"
            },
            "value1Desc": {
                "type": "text",
                "label": "Value1 Desc"
            },
            "value2Title": {
                "type": "text",
                "label": "Value2 Title"
            },
            "value2Desc": {
                "type": "text",
                "label": "Value2 Desc"
            },
            "value3Title": {
                "type": "text",
                "label": "Value3 Title"
            },
            "value3Desc": {
                "type": "text",
                "label": "Value3 Desc"
            },
            "timelineLabel": {
                "type": "text",
                "label": "Timeline Label"
            },
            "timelineTitle": {
                "type": "text",
                "label": "Timeline Title"
            },
            "timeline1Year": {
                "type": "text",
                "label": "Timeline1 Year"
            },
            "timeline1Title": {
                "type": "text",
                "label": "Timeline1 Title"
            },
            "timeline1Desc": {
                "type": "textarea",
                "label": "Timeline1 Desc"
            },
            "timeline2Year": {
                "type": "text",
                "label": "Timeline2 Year"
            },
            "timeline2Title": {
                "type": "text",
                "label": "Timeline2 Title"
            },
            "timeline2Desc": {
                "type": "textarea",
                "label": "Timeline2 Desc"
            },
            "timeline3Year": {
                "type": "text",
                "label": "Timeline3 Year"
            },
            "timeline3Title": {
                "type": "text",
                "label": "Timeline3 Title"
            },
            "timeline3Desc": {
                "type": "textarea",
                "label": "Timeline3 Desc"
            },
            "timeline4Year": {
                "type": "text",
                "label": "Timeline4 Year"
            },
            "timeline4Title": {
                "type": "text",
                "label": "Timeline4 Title"
            },
            "timeline4Desc": {
                "type": "textarea",
                "label": "Timeline4 Desc"
            },
            "timeline5Year": {
                "type": "text",
                "label": "Timeline5 Year"
            },
            "timeline5Title": {
                "type": "text",
                "label": "Timeline5 Title"
            },
            "timeline5Desc": {
                "type": "text",
                "label": "Timeline5 Desc"
            },
            "missionTitle": {
                "type": "text",
                "label": "Mission Title"
            },
            "missionDesc": {
                "type": "textarea",
                "label": "Mission Desc"
            },
            "visionTitle": {
                "type": "text",
                "label": "Vision Title"
            },
            "visionDesc": {
                "type": "textarea",
                "label": "Vision Desc"
            },
            "teamLabel": {
                "type": "text",
                "label": "Team Label"
            },
            "teamTitle": {
                "type": "text",
                "label": "Team Title"
            },
            "ctaTitle": {
                "type": "text",
                "label": "Cta Title"
            },
            "ctaDesc": {
                "type": "text",
                "label": "Cta Desc"
            },
            "ctaBtn": {
                "type": "text",
                "label": "Cta Btn"
            }
        }
    },
    "whoWeArePage": {
        "label": "Biz Kimiz",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDescription": {
                "type": "text",
                "label": "Hero Description"
            },
            "breadcrumbLabel": {
                "type": "text",
                "label": "Breadcrumb Label"
            },
            "breadcrumbCurrent": {
                "type": "text",
                "label": "Breadcrumb Current"
            },
            "sectionLabel": {
                "type": "text",
                "label": "Section Label"
            },
            "sectionTitle": {
                "type": "text",
                "label": "Section Title"
            },
            "description1": {
                "type": "textarea",
                "label": "Description1"
            },
            "description2": {
                "type": "textarea",
                "label": "Description2"
            },
            "check1": {
                "type": "text",
                "label": "Check1"
            },
            "check2": {
                "type": "text",
                "label": "Check2"
            },
            "check3": {
                "type": "text",
                "label": "Check3"
            },
            "check4": {
                "type": "text",
                "label": "Check4"
            },
            "stat1Value": {
                "type": "text",
                "label": "Stat1 Value"
            },
            "stat1Label": {
                "type": "text",
                "label": "Stat1 Label"
            },
            "stat2Value": {
                "type": "text",
                "label": "Stat2 Value"
            },
            "stat2Label": {
                "type": "text",
                "label": "Stat2 Label"
            },
            "stat3Value": {
                "type": "text",
                "label": "Stat3 Value"
            },
            "stat3Label": {
                "type": "text",
                "label": "Stat3 Label"
            },
            "stat4Value": {
                "type": "text",
                "label": "Stat4 Value"
            },
            "stat4Label": {
                "type": "text",
                "label": "Stat4 Label"
            },
            "strengthsLabel": {
                "type": "text",
                "label": "Strengths Label"
            },
            "strengthsTitle": {
                "type": "text",
                "label": "Strengths Title"
            },
            "strengthsDesc": {
                "type": "textarea",
                "label": "Strengths Desc"
            },
            "strength1Title": {
                "type": "text",
                "label": "Strength1 Title"
            },
            "strength1Desc": {
                "type": "textarea",
                "label": "Strength1 Desc"
            },
            "strength2Title": {
                "type": "text",
                "label": "Strength2 Title"
            },
            "strength2Desc": {
                "type": "textarea",
                "label": "Strength2 Desc"
            },
            "strength3Title": {
                "type": "text",
                "label": "Strength3 Title"
            },
            "strength3Desc": {
                "type": "textarea",
                "label": "Strength3 Desc"
            },
            "strength4Title": {
                "type": "text",
                "label": "Strength4 Title"
            },
            "strength4Desc": {
                "type": "textarea",
                "label": "Strength4 Desc"
            },
            "strength5Title": {
                "type": "text",
                "label": "Strength5 Title"
            },
            "strength5Desc": {
                "type": "textarea",
                "label": "Strength5 Desc"
            },
            "strength6Title": {
                "type": "text",
                "label": "Strength6 Title"
            },
            "strength6Desc": {
                "type": "textarea",
                "label": "Strength6 Desc"
            },
            "ctaTitle": {
                "type": "text",
                "label": "Cta Title"
            },
            "ctaDesc": {
                "type": "text",
                "label": "Cta Desc"
            },
            "ctaBtn": {
                "type": "text",
                "label": "Cta Btn"
            }
        }
    },
    "missionVisionPage": {
        "label": "Misyon & Vizyon",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDescription": {
                "type": "text",
                "label": "Hero Description"
            },
            "breadcrumbLabel": {
                "type": "text",
                "label": "Breadcrumb Label"
            },
            "breadcrumbCurrent": {
                "type": "text",
                "label": "Breadcrumb Current"
            },
            "missionTitle": {
                "type": "text",
                "label": "Mission Title"
            },
            "missionDesc1": {
                "type": "textarea",
                "label": "Mission Desc1"
            },
            "missionDesc2": {
                "type": "textarea",
                "label": "Mission Desc2"
            },
            "visionTitle": {
                "type": "text",
                "label": "Vision Title"
            },
            "visionDesc1": {
                "type": "textarea",
                "label": "Vision Desc1"
            },
            "visionDesc2": {
                "type": "textarea",
                "label": "Vision Desc2"
            },
            "goalsLabel": {
                "type": "text",
                "label": "Goals Label"
            },
            "goalsTitle": {
                "type": "text",
                "label": "Goals Title"
            },
            "goalsDesc": {
                "type": "textarea",
                "label": "Goals Desc"
            },
            "goal1Title": {
                "type": "text",
                "label": "Goal1 Title"
            },
            "goal1Desc": {
                "type": "textarea",
                "label": "Goal1 Desc"
            },
            "goal2Title": {
                "type": "text",
                "label": "Goal2 Title"
            },
            "goal2Desc": {
                "type": "textarea",
                "label": "Goal2 Desc"
            },
            "goal3Title": {
                "type": "text",
                "label": "Goal3 Title"
            },
            "goal3Desc": {
                "type": "textarea",
                "label": "Goal3 Desc"
            },
            "goal4Title": {
                "type": "text",
                "label": "Goal4 Title"
            },
            "goal4Desc": {
                "type": "textarea",
                "label": "Goal4 Desc"
            },
            "ctaTitle": {
                "type": "text",
                "label": "Cta Title"
            },
            "ctaDesc": {
                "type": "text",
                "label": "Cta Desc"
            },
            "ctaBtn": {
                "type": "text",
                "label": "Cta Btn"
            }
        }
    },
    "valuesPage": {
        "label": "Değerlerimiz",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "introText": {
                "type": "textarea",
                "label": "Intro Text"
            },
            "value1Title": {
                "type": "text",
                "label": "Value1 Title"
            },
            "value1Desc": {
                "type": "textarea",
                "label": "Value1 Desc"
            },
            "value2Title": {
                "type": "text",
                "label": "Value2 Title"
            },
            "value2Desc": {
                "type": "textarea",
                "label": "Value2 Desc"
            },
            "value3Title": {
                "type": "text",
                "label": "Value3 Title"
            },
            "value3Desc": {
                "type": "textarea",
                "label": "Value3 Desc"
            },
            "value4Title": {
                "type": "text",
                "label": "Value4 Title"
            },
            "value4Desc": {
                "type": "textarea",
                "label": "Value4 Desc"
            },
            "value5Title": {
                "type": "text",
                "label": "Value5 Title"
            },
            "value5Desc": {
                "type": "textarea",
                "label": "Value5 Desc"
            },
            "value6Title": {
                "type": "text",
                "label": "Value6 Title"
            },
            "value6Desc": {
                "type": "textarea",
                "label": "Value6 Desc"
            }
        }
    },
    "qualityPolicyPage": {
        "label": "Kalite Politikamız",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDescription": {
                "type": "textarea",
                "label": "Hero Description"
            },
            "principle1Title": {
                "type": "text",
                "label": "Principle1 Title"
            },
            "principle1Desc": {
                "type": "textarea",
                "label": "Principle1 Desc"
            },
            "principle2Title": {
                "type": "text",
                "label": "Principle2 Title"
            },
            "principle2Desc": {
                "type": "textarea",
                "label": "Principle2 Desc"
            },
            "principle3Title": {
                "type": "text",
                "label": "Principle3 Title"
            },
            "principle3Desc": {
                "type": "textarea",
                "label": "Principle3 Desc"
            },
            "principle4Title": {
                "type": "text",
                "label": "Principle4 Title"
            },
            "principle4Desc": {
                "type": "textarea",
                "label": "Principle4 Desc"
            },
            "principle5Title": {
                "type": "text",
                "label": "Principle5 Title"
            },
            "principle5Desc": {
                "type": "textarea",
                "label": "Principle5 Desc"
            },
            "principle6Title": {
                "type": "text",
                "label": "Principle6 Title"
            },
            "principle6Desc": {
                "type": "textarea",
                "label": "Principle6 Desc"
            },
            "principle7Title": {
                "type": "text",
                "label": "Principle7 Title"
            },
            "principle7Desc": {
                "type": "textarea",
                "label": "Principle7 Desc"
            }
        }
    },
    "historyPage": {
        "label": "Tarihçe",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDesc": {
                "type": "text",
                "label": "Hero Desc"
            },
            "breadcrumbLabel": {
                "type": "text",
                "label": "Breadcrumb Label"
            },
            "breadcrumbCurrent": {
                "type": "text",
                "label": "Breadcrumb Current"
            },
            "timelineLabel": {
                "type": "text",
                "label": "Timeline Label"
            },
            "timelineTitle": {
                "type": "text",
                "label": "Timeline Title"
            },
            "timelineCount": {
                "type": "text",
                "label": "Timeline Count"
            },
            "item1Year": {
                "type": "text",
                "label": "Item1 Year"
            },
            "item1Title": {
                "type": "text",
                "label": "Item1 Title"
            },
            "item1Desc": {
                "type": "textarea",
                "label": "Item1 Desc"
            },
            "item2Year": {
                "type": "text",
                "label": "Item2 Year"
            },
            "item2Title": {
                "type": "text",
                "label": "Item2 Title"
            },
            "item2Desc": {
                "type": "textarea",
                "label": "Item2 Desc"
            },
            "item3Year": {
                "type": "text",
                "label": "Item3 Year"
            },
            "item3Title": {
                "type": "text",
                "label": "Item3 Title"
            },
            "item3Desc": {
                "type": "textarea",
                "label": "Item3 Desc"
            },
            "item4Year": {
                "type": "text",
                "label": "Item4 Year"
            },
            "item4Title": {
                "type": "text",
                "label": "Item4 Title"
            },
            "item4Desc": {
                "type": "textarea",
                "label": "Item4 Desc"
            },
            "item5Year": {
                "type": "text",
                "label": "Item5 Year"
            },
            "item5Title": {
                "type": "text",
                "label": "Item5 Title"
            },
            "item5Desc": {
                "type": "textarea",
                "label": "Item5 Desc"
            },
            "item6Year": {
                "type": "text",
                "label": "Item6 Year"
            },
            "item6Title": {
                "type": "text",
                "label": "Item6 Title"
            },
            "item6Desc": {
                "type": "textarea",
                "label": "Item6 Desc"
            },
            "item7Year": {
                "type": "text",
                "label": "Item7 Year"
            },
            "item7Title": {
                "type": "text",
                "label": "Item7 Title"
            },
            "item7Desc": {
                "type": "textarea",
                "label": "Item7 Desc"
            },
            "item8Year": {
                "type": "text",
                "label": "Item8 Year"
            },
            "item8Title": {
                "type": "text",
                "label": "Item8 Title"
            },
            "item8Desc": {
                "type": "textarea",
                "label": "Item8 Desc"
            },
            "item9Year": {
                "type": "text",
                "label": "Item9 Year"
            },
            "item9Title": {
                "type": "text",
                "label": "Item9 Title"
            },
            "item9Desc": {
                "type": "textarea",
                "label": "Item9 Desc"
            },
            "item10Year": {
                "type": "text",
                "label": "Item10 Year"
            },
            "item10Title": {
                "type": "text",
                "label": "Item10 Title"
            },
            "item10Desc": {
                "type": "textarea",
                "label": "Item10 Desc"
            },
            "item11Year": {
                "type": "text",
                "label": "Item11 Year"
            },
            "item11Title": {
                "type": "text",
                "label": "Item11 Title"
            },
            "item11Desc": {
                "type": "textarea",
                "label": "Item11 Desc"
            },
            "item12Year": {
                "type": "text",
                "label": "Item12 Year"
            },
            "item12Title": {
                "type": "text",
                "label": "Item12 Title"
            },
            "item12Desc": {
                "type": "textarea",
                "label": "Item12 Desc"
            },
            "item13Year": {
                "type": "text",
                "label": "Item13 Year"
            },
            "item13Title": {
                "type": "text",
                "label": "Item13 Title"
            },
            "item13Desc": {
                "type": "textarea",
                "label": "Item13 Desc"
            },
            "item14Year": {
                "type": "text",
                "label": "Item14 Year"
            },
            "item14Title": {
                "type": "text",
                "label": "Item14 Title"
            },
            "item14Desc": {
                "type": "textarea",
                "label": "Item14 Desc"
            },
            "item15Year": {
                "type": "text",
                "label": "Item15 Year"
            },
            "item15Title": {
                "type": "text",
                "label": "Item15 Title"
            },
            "item15Desc": {
                "type": "textarea",
                "label": "Item15 Desc"
            },
            "item16Year": {
                "type": "text",
                "label": "Item16 Year"
            },
            "item16Title": {
                "type": "text",
                "label": "Item16 Title"
            },
            "item16Desc": {
                "type": "textarea",
                "label": "Item16 Desc"
            },
            "item17Year": {
                "type": "text",
                "label": "Item17 Year"
            },
            "item17Title": {
                "type": "text",
                "label": "Item17 Title"
            },
            "item17Desc": {
                "type": "textarea",
                "label": "Item17 Desc"
            },
            "item18Year": {
                "type": "text",
                "label": "Item18 Year"
            },
            "item18Title": {
                "type": "text",
                "label": "Item18 Title"
            },
            "item18Desc": {
                "type": "textarea",
                "label": "Item18 Desc"
            },
            "item19Year": {
                "type": "text",
                "label": "Item19 Year"
            },
            "item19Title": {
                "type": "text",
                "label": "Item19 Title"
            },
            "item19Desc": {
                "type": "textarea",
                "label": "Item19 Desc"
            },
            "item20Year": {
                "type": "text",
                "label": "Item20 Year"
            },
            "item20Title": {
                "type": "text",
                "label": "Item20 Title"
            },
            "item20Desc": {
                "type": "textarea",
                "label": "Item20 Desc"
            },
            "item21Year": {
                "type": "text",
                "label": "Item21 Year"
            },
            "item21Title": {
                "type": "text",
                "label": "Item21 Title"
            },
            "item21Desc": {
                "type": "textarea",
                "label": "Item21 Desc"
            },
            "ctaTitle": {
                "type": "text",
                "label": "Cta Title"
            },
            "ctaDesc": {
                "type": "text",
                "label": "Cta Desc"
            },
            "ctaBtn": {
                "type": "text",
                "label": "Cta Btn"
            }
        }
    },
    "socialResponsibilityPage": {
        "label": "Sosyal Sorumluluk",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDesc": {
                "type": "text",
                "label": "Hero Desc"
            },
            "project1Title": {
                "type": "text",
                "label": "Project1 Title"
            },
            "project1Desc": {
                "type": "textarea",
                "label": "Project1 Desc"
            },
            "project1Full": {
                "type": "textarea",
                "label": "Project1 Full"
            },
            "project1Image": {
                "type": "textarea",
                "label": "Project1 Image"
            },
            "project2Title": {
                "type": "text",
                "label": "Project2 Title"
            },
            "project2Desc": {
                "type": "textarea",
                "label": "Project2 Desc"
            },
            "project2Full": {
                "type": "textarea",
                "label": "Project2 Full"
            },
            "project2Image": {
                "type": "textarea",
                "label": "Project2 Image"
            },
            "project3Title": {
                "type": "text",
                "label": "Project3 Title"
            },
            "project3Desc": {
                "type": "textarea",
                "label": "Project3 Desc"
            },
            "project3Full": {
                "type": "textarea",
                "label": "Project3 Full"
            },
            "project3Image": {
                "type": "textarea",
                "label": "Project3 Image"
            },
            "project4Title": {
                "type": "text",
                "label": "Project4 Title"
            },
            "project4Desc": {
                "type": "textarea",
                "label": "Project4 Desc"
            },
            "project4Full": {
                "type": "textarea",
                "label": "Project4 Full"
            },
            "project4Image": {
                "type": "textarea",
                "label": "Project4 Image"
            },
            "project5Title": {
                "type": "text",
                "label": "Project5 Title"
            },
            "project5Desc": {
                "type": "textarea",
                "label": "Project5 Desc"
            },
            "project5Full": {
                "type": "textarea",
                "label": "Project5 Full"
            },
            "project5Image": {
                "type": "textarea",
                "label": "Project5 Image"
            },
            "readMore": {
                "type": "text",
                "label": "Read More"
            },
            "hide": {
                "type": "text",
                "label": "Hide"
            }
        }
    },
    "informationSocietyPage": {
        "label": "Bilgi Toplumu Hizmetleri",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDesc": {
                "type": "textarea",
                "label": "Hero Desc"
            },
            "breadcrumbLabel": {
                "type": "text",
                "label": "Breadcrumb Label"
            },
            "breadcrumbCurrent": {
                "type": "text",
                "label": "Breadcrumb Current"
            },
            "tradeInfoTitle": {
                "type": "text",
                "label": "Trade Info Title"
            },
            "labelCompanyType": {
                "type": "text",
                "label": "Label Company Type"
            },
            "valueCompanyType": {
                "type": "text",
                "label": "Value Company Type"
            },
            "labelMersisNo": {
                "type": "text",
                "label": "Label Mersis No"
            },
            "valueMersisNo": {
                "type": "text",
                "label": "Value Mersis No"
            },
            "labelTradeRegistryOffice": {
                "type": "text",
                "label": "Label Trade Registry Office"
            },
            "valueTradeRegistryOffice": {
                "type": "text",
                "label": "Value Trade Registry Office"
            },
            "labelTradeRegistryNo": {
                "type": "text",
                "label": "Label Trade Registry No"
            },
            "valueTradeRegistryNo": {
                "type": "text",
                "label": "Value Trade Registry No"
            },
            "labelTradeTitle": {
                "type": "text",
                "label": "Label Trade Title"
            },
            "valueTradeTitle": {
                "type": "text",
                "label": "Value Trade Title"
            },
            "labelAddress": {
                "type": "text",
                "label": "Label Address"
            },
            "valueAddress": {
                "type": "textarea",
                "label": "Value Address"
            },
            "labelCommittedCapital": {
                "type": "text",
                "label": "Label Committed Capital"
            },
            "valueCommittedCapital": {
                "type": "text",
                "label": "Value Committed Capital"
            },
            "labelPaidCapital": {
                "type": "text",
                "label": "Label Paid Capital"
            },
            "valuePaidCapital": {
                "type": "text",
                "label": "Value Paid Capital"
            },
            "labelRegisteredCapitalCeiling": {
                "type": "text",
                "label": "Label Registered Capital Ceiling"
            },
            "valueRegisteredCapitalCeiling": {
                "type": "text",
                "label": "Value Registered Capital Ceiling"
            },
            "labelTaxOffice": {
                "type": "text",
                "label": "Label Tax Office"
            },
            "valueTaxOffice": {
                "type": "text",
                "label": "Value Tax Office"
            },
            "labelTaxNo": {
                "type": "text",
                "label": "Label Tax No"
            },
            "valueTaxNo": {
                "type": "text",
                "label": "Value Tax No"
            },
            "managementInfoTitle": {
                "type": "text",
                "label": "Management Info Title"
            },
            "labelChairman": {
                "type": "text",
                "label": "Label Chairman"
            },
            "valueChairman": {
                "type": "text",
                "label": "Value Chairman"
            },
            "auditorInfoTitle": {
                "type": "text",
                "label": "Auditor Info Title"
            },
            "labelAuditorTitle": {
                "type": "text",
                "label": "Label Auditor Title"
            },
            "valueAuditorTitle": {
                "type": "text",
                "label": "Value Auditor Title"
            },
            "labelAuditorPeriod": {
                "type": "text",
                "label": "Label Auditor Period"
            },
            "valueAuditorPeriod": {
                "type": "text",
                "label": "Value Auditor Period"
            },
            "labelAuditorAddress": {
                "type": "text",
                "label": "Label Auditor Address"
            },
            "valueAuditorAddress": {
                "type": "text",
                "label": "Value Auditor Address"
            },
            "contactInfoTitle": {
                "type": "text",
                "label": "Contact Info Title"
            },
            "labelPhone": {
                "type": "text",
                "label": "Label Phone"
            },
            "valuePhone": {
                "type": "text",
                "label": "Value Phone"
            },
            "labelFax": {
                "type": "text",
                "label": "Label Fax"
            },
            "valueFax": {
                "type": "text",
                "label": "Value Fax"
            },
            "labelKep": {
                "type": "text",
                "label": "Label Kep"
            },
            "valueKep": {
                "type": "text",
                "label": "Value Kep"
            },
            "labelWebsites": {
                "type": "text",
                "label": "Label Websites"
            },
            "valueWebsites": {
                "type": "text",
                "label": "Value Websites"
            },
            "footerNote": {
                "type": "textarea",
                "label": "Footer Note"
            }
        }
    },
    "brandsPage": {
        "label": "Markalarımız Sayfası",
        "group": "pages",
        "fields": {
            "title": {
                "type": "text",
                "label": "Title"
            },
            "breadcrumbLabel": {
                "type": "text",
                "label": "Breadcrumb Label"
            },
            "badge": {
                "type": "text",
                "label": "Badge"
            }
        }
    },
    "brandDetail": {
        "label": "Marka Detay",
        "group": "pages",
        "fields": {
            "brand": {
                "type": "text",
                "label": "Brand"
            },
            "productGroups": {
                "type": "text",
                "label": "Product Groups"
            },
            "productGroupsDesc": {
                "type": "text",
                "label": "Product Groups Desc"
            },
            "backToBrands": {
                "type": "text",
                "label": "Back To Brands"
            },
            "documentsTitle": {
                "type": "text",
                "label": "Documents Title"
            },
            "documentsDesc": {
                "type": "textarea",
                "label": "Documents Desc"
            },
            "documentsDownload": {
                "type": "text",
                "label": "Documents Download"
            },
            "documentsFallback": {
                "type": "text",
                "label": "Documents Fallback"
            },
            "relatedPosts": {
                "type": "text",
                "label": "Related Posts"
            },
            "readMore": {
                "type": "text",
                "label": "Read More"
            }
        }
    },
    "supportPage": {
        "label": "Teknik Destek",
        "group": "pages",
        "fields": {
            "title": {
                "type": "text",
                "label": "Title"
            },
            "subtitle": {
                "type": "text",
                "label": "Subtitle"
            },
            "description": {
                "type": "text",
                "label": "Description"
            },
            "processLabel": {
                "type": "text",
                "label": "Process Label"
            },
            "processTitle": {
                "type": "text",
                "label": "Process Title"
            },
            "step1Title": {
                "type": "text",
                "label": "Step1 Title"
            },
            "step1Desc": {
                "type": "text",
                "label": "Step1 Desc"
            },
            "step2Title": {
                "type": "text",
                "label": "Step2 Title"
            },
            "step2Desc": {
                "type": "text",
                "label": "Step2 Desc"
            },
            "step3Title": {
                "type": "text",
                "label": "Step3 Title"
            },
            "step3Desc": {
                "type": "text",
                "label": "Step3 Desc"
            },
            "step4Title": {
                "type": "text",
                "label": "Step4 Title"
            },
            "step4Desc": {
                "type": "text",
                "label": "Step4 Desc"
            },
            "feature1Title": {
                "type": "text",
                "label": "Feature1 Title"
            },
            "feature1Desc": {
                "type": "text",
                "label": "Feature1 Desc"
            },
            "feature2Title": {
                "type": "text",
                "label": "Feature2 Title"
            },
            "feature2Desc": {
                "type": "text",
                "label": "Feature2 Desc"
            },
            "feature3Title": {
                "type": "text",
                "label": "Feature3 Title"
            },
            "feature3Desc": {
                "type": "text",
                "label": "Feature3 Desc"
            },
            "formLabel": {
                "type": "text",
                "label": "Form Label"
            },
            "formTitle": {
                "type": "text",
                "label": "Form Title"
            },
            "formDesc": {
                "type": "textarea",
                "label": "Form Desc"
            },
            "formName": {
                "type": "text",
                "label": "Form Name"
            },
            "formNamePlaceholder": {
                "type": "text",
                "label": "Form Name Placeholder"
            },
            "formSurname": {
                "type": "text",
                "label": "Form Surname"
            },
            "formSurnamePlaceholder": {
                "type": "text",
                "label": "Form Surname Placeholder"
            },
            "formEmail": {
                "type": "text",
                "label": "Form Email"
            },
            "formEmailPlaceholder": {
                "type": "text",
                "label": "Form Email Placeholder"
            },
            "formPhone": {
                "type": "text",
                "label": "Form Phone"
            },
            "formPhonePlaceholder": {
                "type": "text",
                "label": "Form Phone Placeholder"
            },
            "formSubject": {
                "type": "text",
                "label": "Form Subject"
            },
            "formSubjectPlaceholder": {
                "type": "text",
                "label": "Form Subject Placeholder"
            },
            "formMessage": {
                "type": "text",
                "label": "Form Message"
            },
            "formMessagePlaceholder": {
                "type": "text",
                "label": "Form Message Placeholder"
            },
            "formSubmit": {
                "type": "text",
                "label": "Form Submit"
            },
            "formSending": {
                "type": "text",
                "label": "Form Sending"
            },
            "formSuccessTitle": {
                "type": "text",
                "label": "Form Success Title"
            },
            "formSuccessDesc": {
                "type": "text",
                "label": "Form Success Desc"
            },
            "formNewRequest": {
                "type": "text",
                "label": "Form New Request"
            },
            "formError": {
                "type": "text",
                "label": "Form Error"
            },
            "formConnectionError": {
                "type": "text",
                "label": "Form Connection Error"
            },
            "warrantyTitle": {
                "type": "text",
                "label": "Warranty Title"
            },
            "warrantyDesc": {
                "type": "textarea",
                "label": "Warranty Desc"
            },
            "warrantyBtn": {
                "type": "text",
                "label": "Warranty Btn"
            },
            "contactBtn": {
                "type": "text",
                "label": "Contact Btn"
            }
        }
    },
    "warrantyPage": {
        "label": "Garanti Şartları",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDesc": {
                "type": "textarea",
                "label": "Hero Desc"
            },
            "key1Title": {
                "type": "text",
                "label": "Key1 Title"
            },
            "key1Desc": {
                "type": "text",
                "label": "Key1 Desc"
            },
            "key2Title": {
                "type": "text",
                "label": "Key2 Title"
            },
            "key2Desc": {
                "type": "text",
                "label": "Key2 Desc"
            },
            "key3Title": {
                "type": "text",
                "label": "Key3 Title"
            },
            "key3Desc": {
                "type": "text",
                "label": "Key3 Desc"
            },
            "term1Title": {
                "type": "text",
                "label": "Term1 Title"
            },
            "term1Content": {
                "type": "textarea",
                "label": "Term1 Content"
            },
            "term2Title": {
                "type": "text",
                "label": "Term2 Title"
            },
            "term2Content": {
                "type": "text",
                "label": "Term2 Content"
            },
            "term2Item1": {
                "type": "text",
                "label": "Term2 Item1"
            },
            "term2Item2": {
                "type": "text",
                "label": "Term2 Item2"
            },
            "term2Item3": {
                "type": "text",
                "label": "Term2 Item3"
            },
            "term2Item4": {
                "type": "text",
                "label": "Term2 Item4"
            },
            "term2Item5": {
                "type": "textarea",
                "label": "Term2 Item5"
            },
            "term2Item6": {
                "type": "text",
                "label": "Term2 Item6"
            },
            "term2Item7": {
                "type": "text",
                "label": "Term2 Item7"
            },
            "term2Item8": {
                "type": "text",
                "label": "Term2 Item8"
            },
            "term3Title": {
                "type": "text",
                "label": "Term3 Title"
            },
            "term3Content": {
                "type": "textarea",
                "label": "Term3 Content"
            },
            "term3Item1": {
                "type": "text",
                "label": "Term3 Item1"
            },
            "term3Item2": {
                "type": "text",
                "label": "Term3 Item2"
            },
            "term3Item3": {
                "type": "text",
                "label": "Term3 Item3"
            },
            "term3Item4": {
                "type": "text",
                "label": "Term3 Item4"
            },
            "term3Item5": {
                "type": "text",
                "label": "Term3 Item5"
            },
            "term4Title": {
                "type": "text",
                "label": "Term4 Title"
            },
            "term4Content": {
                "type": "textarea",
                "label": "Term4 Content"
            },
            "term5Title": {
                "type": "text",
                "label": "Term5 Title"
            },
            "term5Content": {
                "type": "textarea",
                "label": "Term5 Content"
            },
            "term6Title": {
                "type": "text",
                "label": "Term6 Title"
            },
            "term6Content": {
                "type": "textarea",
                "label": "Term6 Content"
            },
            "ctaTitle": {
                "type": "text",
                "label": "Cta Title"
            },
            "ctaDesc": {
                "type": "textarea",
                "label": "Cta Desc"
            },
            "ctaFormBtn": {
                "type": "text",
                "label": "Cta Form Btn"
            },
            "ctaPhone": {
                "type": "text",
                "label": "Cta Phone"
            }
        }
    },
    "hrPolicyPage": {
        "label": "İK Politikamız",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "introDesc": {
                "type": "textarea",
                "label": "Intro Desc"
            },
            "principlesLabel": {
                "type": "text",
                "label": "Principles Label"
            },
            "principlesTitle": {
                "type": "text",
                "label": "Principles Title"
            },
            "principle1Title": {
                "type": "text",
                "label": "Principle1 Title"
            },
            "principle1Desc": {
                "type": "textarea",
                "label": "Principle1 Desc"
            },
            "principle2Title": {
                "type": "text",
                "label": "Principle2 Title"
            },
            "principle2Desc": {
                "type": "textarea",
                "label": "Principle2 Desc"
            },
            "principle3Title": {
                "type": "text",
                "label": "Principle3 Title"
            },
            "principle3Desc": {
                "type": "textarea",
                "label": "Principle3 Desc"
            },
            "principle4Title": {
                "type": "text",
                "label": "Principle4 Title"
            },
            "principle4Desc": {
                "type": "textarea",
                "label": "Principle4 Desc"
            },
            "principle5Title": {
                "type": "text",
                "label": "Principle5 Title"
            },
            "principle5Desc": {
                "type": "textarea",
                "label": "Principle5 Desc"
            },
            "principle6Title": {
                "type": "text",
                "label": "Principle6 Title"
            },
            "principle6Desc": {
                "type": "textarea",
                "label": "Principle6 Desc"
            },
            "whyLabel": {
                "type": "text",
                "label": "Why Label"
            },
            "whyTitle": {
                "type": "text",
                "label": "Why Title"
            },
            "whyItem1Title": {
                "type": "text",
                "label": "Why Item1 Title"
            },
            "whyItem1Desc": {
                "type": "textarea",
                "label": "Why Item1 Desc"
            },
            "whyItem2Title": {
                "type": "text",
                "label": "Why Item2 Title"
            },
            "whyItem2Desc": {
                "type": "textarea",
                "label": "Why Item2 Desc"
            },
            "whyItem3Title": {
                "type": "text",
                "label": "Why Item3 Title"
            },
            "whyItem3Desc": {
                "type": "textarea",
                "label": "Why Item3 Desc"
            },
            "whyItem4Title": {
                "type": "text",
                "label": "Why Item4 Title"
            },
            "whyItem4Desc": {
                "type": "textarea",
                "label": "Why Item4 Desc"
            }
        }
    },
    "careerPage": {
        "label": "Kariyer",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "introTitle": {
                "type": "text",
                "label": "Intro Title"
            },
            "introDesc": {
                "type": "textarea",
                "label": "Intro Desc"
            },
            "openPositions": {
                "type": "text",
                "label": "Open Positions"
            },
            "noJobs": {
                "type": "text",
                "label": "No Jobs"
            },
            "applyNow": {
                "type": "text",
                "label": "Apply Now"
            },
            "location": {
                "type": "text",
                "label": "Location"
            },
            "department": {
                "type": "text",
                "label": "Department"
            },
            "type": {
                "type": "text",
                "label": "Type"
            },
            "details": {
                "type": "text",
                "label": "Details"
            },
            "applyTitle": {
                "type": "text",
                "label": "Apply Title"
            },
            "applyFormName": {
                "type": "text",
                "label": "Apply Form Name"
            },
            "applyFormEmail": {
                "type": "text",
                "label": "Apply Form Email"
            },
            "applyFormPhone": {
                "type": "text",
                "label": "Apply Form Phone"
            },
            "applyFormCoverLetter": {
                "type": "text",
                "label": "Apply Form Cover Letter"
            },
            "applyFormSubmit": {
                "type": "text",
                "label": "Apply Form Submit"
            },
            "applyFormSending": {
                "type": "text",
                "label": "Apply Form Sending"
            },
            "applySuccess": {
                "type": "text",
                "label": "Apply Success"
            },
            "applySuccessDesc": {
                "type": "textarea",
                "label": "Apply Success Desc"
            },
            "applyError": {
                "type": "text",
                "label": "Apply Error"
            },
            "applyFormCv": {
                "type": "text",
                "label": "Apply Form Cv"
            },
            "applyFormCvHint": {
                "type": "text",
                "label": "Apply Form Cv Hint"
            },
            "applyFormCvDrop": {
                "type": "text",
                "label": "Apply Form Cv Drop"
            },
            "applyFormCvBrowse": {
                "type": "text",
                "label": "Apply Form Cv Browse"
            },
            "applyFormKvkk": {
                "type": "textarea",
                "label": "Apply Form Kvkk"
            },
            "applyCvRequired": {
                "type": "text",
                "label": "Apply Cv Required"
            },
            "applyKvkkRequired": {
                "type": "text",
                "label": "Apply Kvkk Required"
            },
            "applyTurnstileError": {
                "type": "text",
                "label": "Apply Turnstile Error"
            }
        }
    },
    "contactPage": {
        "label": "İletişim Sayfası",
        "group": "pages",
        "fields": {
            "title": {
                "type": "text",
                "label": "Title"
            },
            "subtitle": {
                "type": "text",
                "label": "Subtitle"
            },
            "description": {
                "type": "text",
                "label": "Description"
            },
            "addressTitle": {
                "type": "text",
                "label": "Address Title"
            },
            "addressLine1": {
                "type": "text",
                "label": "Address Line1"
            },
            "addressLine2": {
                "type": "text",
                "label": "Address Line2"
            },
            "addressLine3": {
                "type": "text",
                "label": "Address Line3"
            },
            "phoneTitle": {
                "type": "text",
                "label": "Phone Title"
            },
            "phoneLine": {
                "type": "text",
                "label": "Phone Line"
            },
            "emailTitle": {
                "type": "text",
                "label": "Email Title"
            },
            "emailLine1": {
                "type": "text",
                "label": "Email Line1"
            },
            "emailLine2": {
                "type": "text",
                "label": "Email Line2"
            },
            "hoursTitle": {
                "type": "text",
                "label": "Hours Title"
            },
            "hoursLine1": {
                "type": "text",
                "label": "Hours Line1"
            },
            "mapLocation": {
                "type": "text",
                "label": "Map Location"
            },
            "formName": {
                "type": "text",
                "label": "Form Name"
            },
            "formNamePlaceholder": {
                "type": "text",
                "label": "Form Name Placeholder"
            },
            "formCompany": {
                "type": "text",
                "label": "Form Company"
            },
            "formCompanyPlaceholder": {
                "type": "text",
                "label": "Form Company Placeholder"
            },
            "formEmail": {
                "type": "text",
                "label": "Form Email"
            },
            "formEmailPlaceholder": {
                "type": "text",
                "label": "Form Email Placeholder"
            },
            "formPhone": {
                "type": "text",
                "label": "Form Phone"
            },
            "formPhonePlaceholder": {
                "type": "text",
                "label": "Form Phone Placeholder"
            },
            "formSubject": {
                "type": "text",
                "label": "Form Subject"
            },
            "formSubjectPlaceholder": {
                "type": "text",
                "label": "Form Subject Placeholder"
            },
            "formTypeLabel": {
                "type": "text",
                "label": "Form Type Label"
            },
            "formTypeSuggestion": {
                "type": "text",
                "label": "Form Type Suggestion"
            },
            "formTypeComplaint": {
                "type": "text",
                "label": "Form Type Complaint"
            },
            "formTypeRequest": {
                "type": "text",
                "label": "Form Type Request"
            },
            "formTypeObjection": {
                "type": "text",
                "label": "Form Type Objection"
            },
            "formMessage": {
                "type": "text",
                "label": "Form Message"
            },
            "formMessagePlaceholder": {
                "type": "text",
                "label": "Form Message Placeholder"
            },
            "formKvkk": {
                "type": "text",
                "label": "Form Kvkk"
            },
            "formKvkkError": {
                "type": "text",
                "label": "Form Kvkk Error"
            },
            "formTurnstileError": {
                "type": "text",
                "label": "Form Turnstile Error"
            },
            "formSubmit": {
                "type": "text",
                "label": "Form Submit"
            },
            "formSending": {
                "type": "text",
                "label": "Form Sending"
            },
            "formSuccessTitle": {
                "type": "text",
                "label": "Form Success Title"
            },
            "formSuccessDesc": {
                "type": "text",
                "label": "Form Success Desc"
            },
            "formNewMessage": {
                "type": "text",
                "label": "Form New Message"
            },
            "formError": {
                "type": "text",
                "label": "Form Error"
            },
            "formConnectionError": {
                "type": "text",
                "label": "Form Connection Error"
            }
        }
    },
    "partnerPage": {
        "label": "İş Ortağı Başvurusu",
        "group": "pages",
        "fields": {
            "heroBadge": {
                "type": "text",
                "label": "Hero Badge"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "heroDescription": {
                "type": "textarea",
                "label": "Hero Description"
            },
            "processTitle": {
                "type": "text",
                "label": "Process Title"
            },
            "step1": {
                "type": "textarea",
                "label": "Step1"
            },
            "step2": {
                "type": "textarea",
                "label": "Step2"
            },
            "step3": {
                "type": "textarea",
                "label": "Step3"
            },
            "step4": {
                "type": "textarea",
                "label": "Step4"
            },
            "step5": {
                "type": "textarea",
                "label": "Step5"
            },
            "step6": {
                "type": "textarea",
                "label": "Step6"
            },
            "step7": {
                "type": "textarea",
                "label": "Step7"
            },
            "step8": {
                "type": "textarea",
                "label": "Step8"
            },
            "docsTitle": {
                "type": "text",
                "label": "Docs Title"
            },
            "docsSahisTitle": {
                "type": "text",
                "label": "Docs Sahis Title"
            },
            "docsSirketTitle": {
                "type": "text",
                "label": "Docs Sirket Title"
            },
            "docSahis1": {
                "type": "text",
                "label": "Doc Sahis1"
            },
            "docSahis2": {
                "type": "text",
                "label": "Doc Sahis2"
            },
            "docSahis3": {
                "type": "text",
                "label": "Doc Sahis3"
            },
            "docSahis4": {
                "type": "text",
                "label": "Doc Sahis4"
            },
            "docSahis5": {
                "type": "text",
                "label": "Doc Sahis5"
            },
            "docSirket1": {
                "type": "text",
                "label": "Doc Sirket1"
            },
            "docSirket2": {
                "type": "text",
                "label": "Doc Sirket2"
            },
            "docSirket3": {
                "type": "text",
                "label": "Doc Sirket3"
            },
            "docSirket4": {
                "type": "text",
                "label": "Doc Sirket4"
            },
            "docSirket5": {
                "type": "text",
                "label": "Doc Sirket5"
            },
            "contractTitle": {
                "type": "text",
                "label": "Contract Title"
            },
            "contractDesc": {
                "type": "textarea",
                "label": "Contract Desc"
            },
            "contractDownload": {
                "type": "text",
                "label": "Contract Download"
            },
            "formTitle": {
                "type": "text",
                "label": "Form Title"
            },
            "formIntro": {
                "type": "textarea",
                "label": "Form Intro"
            },
            "sectionCompany": {
                "type": "text",
                "label": "Section Company"
            },
            "sectionAddress": {
                "type": "text",
                "label": "Section Address"
            },
            "sectionFinance": {
                "type": "text",
                "label": "Section Finance"
            },
            "sectionDocuments": {
                "type": "text",
                "label": "Section Documents"
            },
            "applicationType": {
                "type": "text",
                "label": "Application Type"
            },
            "typeTuzel": {
                "type": "text",
                "label": "Type Tuzel"
            },
            "typeGercek": {
                "type": "text",
                "label": "Type Gercek"
            },
            "companyName": {
                "type": "text",
                "label": "Company Name"
            },
            "authorizedName": {
                "type": "text",
                "label": "Authorized Name"
            },
            "tckn": {
                "type": "text",
                "label": "Tckn"
            },
            "email": {
                "type": "text",
                "label": "Email"
            },
            "mersisNo": {
                "type": "text",
                "label": "Mersis No"
            },
            "phone": {
                "type": "text",
                "label": "Phone"
            },
            "mobile": {
                "type": "text",
                "label": "Mobile"
            },
            "fax": {
                "type": "text",
                "label": "Fax"
            },
            "country": {
                "type": "text",
                "label": "Country"
            },
            "province": {
                "type": "text",
                "label": "Province"
            },
            "district": {
                "type": "text",
                "label": "District"
            },
            "neighborhood": {
                "type": "text",
                "label": "Neighborhood"
            },
            "postalCode": {
                "type": "text",
                "label": "Postal Code"
            },
            "address": {
                "type": "text",
                "label": "Address"
            },
            "taxOffice": {
                "type": "text",
                "label": "Tax Office"
            },
            "taxNo": {
                "type": "text",
                "label": "Tax No"
            },
            "currency": {
                "type": "text",
                "label": "Currency"
            },
            "iban": {
                "type": "text",
                "label": "Iban"
            },
            "selectProvince": {
                "type": "text",
                "label": "Select Province"
            },
            "selectDistrict": {
                "type": "text",
                "label": "Select District"
            },
            "docBasvuruFormu": {
                "type": "text",
                "label": "Doc Basvuru Formu"
            },
            "docImzaSirkusu": {
                "type": "text",
                "label": "Doc Imza Sirkusu"
            },
            "docVergiLevhasi": {
                "type": "text",
                "label": "Doc Vergi Levhasi"
            },
            "docKimlikler": {
                "type": "text",
                "label": "Doc Kimlikler"
            },
            "docFaaliyet": {
                "type": "text",
                "label": "Doc Faaliyet"
            },
            "fileHint": {
                "type": "text",
                "label": "File Hint"
            },
            "fileChoose": {
                "type": "text",
                "label": "File Choose"
            },
            "fileSelected": {
                "type": "text",
                "label": "File Selected"
            },
            "kvkkConsent": {
                "type": "textarea",
                "label": "Kvkk Consent"
            },
            "marketingConsent": {
                "type": "textarea",
                "label": "Marketing Consent"
            },
            "submit": {
                "type": "text",
                "label": "Submit"
            },
            "sending": {
                "type": "text",
                "label": "Sending"
            },
            "successTitle": {
                "type": "text",
                "label": "Success Title"
            },
            "successDesc": {
                "type": "textarea",
                "label": "Success Desc"
            },
            "newApplication": {
                "type": "text",
                "label": "New Application"
            },
            "requiredFilesError": {
                "type": "text",
                "label": "Required Files Error"
            },
            "turnstileError": {
                "type": "text",
                "label": "Turnstile Error"
            },
            "error": {
                "type": "text",
                "label": "Error"
            },
            "connectionError": {
                "type": "text",
                "label": "Connection Error"
            },
            "fileDrop": {
                "type": "text",
                "label": "File Drop"
            },
            "fileClear": {
                "type": "text",
                "label": "File Clear"
            }
        }
    },
    "kvkkPage": {
        "label": "KVKK Politikası",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "content": {
                "type": "textarea",
                "label": "Content"
            }
        }
    },
    "cookiePolicyPage": {
        "label": "Çerez Politikası",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "content": {
                "type": "textarea",
                "label": "Content"
            }
        }
    },
    "privacyPolicyPage": {
        "label": "Gizlilik Politikası",
        "group": "pages",
        "fields": {
            "heroLabel": {
                "type": "text",
                "label": "Hero Label"
            },
            "heroTitle": {
                "type": "text",
                "label": "Hero Title"
            },
            "content": {
                "type": "textarea",
                "label": "Content"
            }
        }
    },
    "blogPage": {
        "label": "Blog Sayfası",
        "group": "pages",
        "fields": {
            "title": {
                "type": "text",
                "label": "Title"
            },
            "subtitle": {
                "type": "text",
                "label": "Subtitle"
            },
            "description": {
                "type": "text",
                "label": "Description"
            },
            "noPosts": {
                "type": "text",
                "label": "No Posts"
            },
            "readMore": {
                "type": "text",
                "label": "Read More"
            },
            "backToBlog": {
                "type": "text",
                "label": "Back To Blog"
            },
            "backToAll": {
                "type": "text",
                "label": "Back To All"
            },
            "notFoundTitle": {
                "type": "text",
                "label": "Not Found Title"
            },
            "notFoundDesc": {
                "type": "text",
                "label": "Not Found Desc"
            }
        }
    }
};
//# sourceMappingURL=registry.generated.js.map